<template>
  <div class="t-lazyimg" :class="classesParsed">
    <NuxtImg
      :loading="loading"
      class="t-lazyimg__img"
      format="webp"
      quality="80"
      :class="classesImg"
      :alt="
        alt
          ? t('a11y.image-alt', {
              alt,
            })
          : ''
      "
      sizes="320px xs:320px sm:570px md:640px lg:100vw xl:100vw xxl:100vw 2xl:100vw"
      densities="x1"
      :src="srcParsed"
      :placeholder="placeholder"
      :preload="preload ? true : undefined"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { parseProtocol } from '~/utils/parseProtocol'
import type { TLazyimg_Props } from './constants/types'

const props = withDefaults(defineProps<TLazyimg_Props>(), {
  classesImg: 'object-cover absolute inset-0 h-full w-full',
  preload: false,
  loading: 'lazy',
  placeholder: false,
})

const classesParsed = computed(() => {
  if (props.classes !== undefined && props.classes.trim() !== '') {
    return props.classes + ' relative '
  } else {
    return 'absolute inset-0 h-full w-full'
  }
})

const srcParsed = computed(() => {
  return parseProtocol(props.src)
})
</script>
